import mixpanel from 'mixpanel-browser';
import { localStorageUtil } from '../utils/local-storage-util';
import { LocalStorageKeys } from '../constants/enums';
import { getQueryParam } from '../utils/get-query-param';

const bootData = localStorageUtil.get(LocalStorageKeys.BOOT);
const publisherId = bootData?.theme?.publisherId;
const isMixpanelActive = bootData?.externalServicesConfig?.mixpanelActive;
const playerId = getQueryParam('playerId');
const mixPanelId = '36bc8102bd15fc0a7471651e632a1c1d';

export const initProductEventsService = () => {
    if (!isMixpanelActive || !playerId || !publisherId) return;
    mixpanel.init(mixPanelId, { debug: false });
    if (playerId === mixpanel.get_distinct_id()) return;
    mixpanel.identify(`${publisherId}_${playerId}`);
};

export const sendProductEvent = (
    eventType: string,
    options: any
) => {
    const properties = {
        ...options,
        publisher: publisherId,
        environment: process.env.REACT_APP_ENV || 'local'
    };
    try {
        mixpanel.track(eventType, properties);
    } catch (error) {
        console.error(error);
    }
};


